import { render } from "./IconClaims.vue?vue&type=template&id=1ce97587"
import script from "./IconClaims.vue?vue&type=script&lang=js"
export * from "./IconClaims.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__